<div class="upload__target"
     [ngClass]="{'compact': compact}"
     appDragAndDrop
     (fileDropped)="onFileSelected($event)"
     *ngIf="!file"
     role="button"
     aria-label="Upload file.">
  <input type="file"
         accept="{{accept}}"
         style="display: none;"
         #fileFormInput
         (change)="onFileSelected(fileFormInput.files)"
         aria-hidden="true" />
  <button type="button"
          (click)="fileFormInput.click()"
          class="link link--noline"
          aria-label="Click to browse for a file.">
    <i class="far fa-search spacerRight"></i>Browse for a file
  </button>&nbsp;<span class="d-none d-flex--sm">or drag and drop it here.</span>

  <ng-content select="[noFileSelected]"></ng-content>

</div>

<div class="upload__target"
     [ngClass]="{'compact': compact}"
     *ngIf="file"
     role="button"
     aria-label="Uploaded file.">
  <div class="upload__name col__">
    <i class="far fa-file-spreadsheet spacerRight"></i>
    <span class="spacerRight">{{file?.name}}</span>
    <button type="button"
            class="link link--red"
            (click)="onRemoveFileClick()"
            aria-label="Click to remove {{file?.name}}.">
      <i class="fas fa-circle-xmark"></i>
    </button>
  </div>

  <ng-content select="[fileSelected]"></ng-content>
</div>
